export default __webpack_public_path__ + "static/media/p80.2eb5903c.jpg";